import styled from 'styled-components';

export const Content = styled.div.attrs({
  className: 'Content',
  size: props => props.fontSize || '1rem',
  weight: props => props.fontWeight || 'normal',
  family: props => props.fontFamily || 'Montserrat',
  lineheight: props => props.lineheight || '1.8rem',
  color: props => props.color || '#4a4a4a'
})`
  font-family: ${props => props.family};
  font-size: ${props => props.size};
  font-weight: ${props => props.weight};
  line-height: ${props => props.lineheight};
  color: ${props => props.color};
  p:first-of-type {
    margin-top: 0;
  }
  a {
    color: #4db2ec;
  }
  .heavy-font-box-quote {
    font-family: Montserrat;
    font-size: 1.5rem;
    color: #4db2ec;
    font-weight: bold;
    text-transform: uppercase;
    line-height: 1.2;
    font-style: italic;
    p {
      /* border-top: 2px solid #4db2ec;
      border-bottom: 2px solid #4db2ec;
      border-top-left-radius: 20px;
      border-bottom-right-radius: 20px; */
      /* padding: 1rem 1.5rem; */
    }
  }

  .grey-box-quote {
    width: 280px;
    border: solid 2px #4db2ec;
    font-family: Montserrat;
    font-size: 1rem;
    font-weight: bold;
    font-style: italic;
    color: #4db2ec;
    /* text-transform: uppercase; */
    padding: 1rem;
    /* float: left; */
    margin: 12px 12px 12px 0;
    p {
      margin: 0;
    }
  }

  .outline-box-quote {
    margin: 0;
    width: 100%;
    background: #f7f7f7;
    color: #4db2ec;
    font-family: Montserrat;
    font-style: italic;
    font-size: 1.2rem;
    padding: 0.875rem 1.5rem;
    p {
      margin: 0;
    }
  }
`;
